export const GET_DIT_PMS_DASHBOARD = 'GET_DIT_PMS_DASHBOARD';
export const GET_DIT_PMS_DASHBOARD_SUCCESS = 'GET_DIT_PMS_DASHBOARD_SUCCESS';
export const GET_DIT_PMS_DASHBOARD_FAILURE = 'GET_DIT_PMS_DASHBOARD_FAILURE';